import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const TestForPackage = ({ isOpen, onRequestClose, packageId }) => {
  const [loader, setLoader] = useState(false);
  const [testDetails, setTestDetails] = useState([]);
  const navigate = useNavigate();

  const getData = async () => {
    setLoader(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.get(
        `/api/packagetestmapping/packageid=${packageId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setTestDetails(response.data || []);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  useEffect(() => {
    if (packageId) {
      getData();
    }
  }, [packageId]);

  const packageName = testDetails[0]?.pac?.packagename;

  return (
    <>
      {loader && <div className="loading"></div>}
      <Modal show={isOpen} onHide={onRequestClose} centered>
        <Modal.Header closeButton className="hm-card-header">
          <Modal.Title className="hm-card-title">
            <i className="material-icons">science</i>
            Package Tests Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {packageName && (
            <div className="mb-3 p-3 rounded-3 bg-light border">
              <span className="text-muted small d-block">Package Name:</span>
              <h6 className="fw-bold m-0" style={{ color: "#2f3a88" }}>{packageName}</h6>
            </div>
          )}

          <h6 className="fw-bold mb-3">Included Tests ({testDetails.length}):</h6>

          {testDetails.length === 0 ? (
            <p className="text-muted text-center my-3">No test details found for this package</p>
          ) : (
            <ul className="list-group list-group-flush border rounded-3">
              {testDetails.map((test) => (
                <li key={test.id} className="list-group-item d-flex justify-content-between align-items-center py-2 px-3">
                  <div>
                    <span className="fw-semibold text-dark me-2">{test.lab?.testname}</span>
                    <span className="text-muted small">({test.lab?.testCat?.categoryname || "General"})</span>
                  </div>
                  <i className="material-icons text-success" style={{ fontSize: "1.1rem" }}>check_circle</i>
                </li>
              ))}
            </ul>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TestForPackage;
